import { AxiosResponse } from 'axios';
import ApiService from './api.service';
import { TagEndpoint } from './api.endpoints';

class TagService extends ApiService {
  async createTag(payload: any): Promise<AxiosResponse | undefined> {
    const response = await this.post(TagEndpoint.CREATE, payload);
    return response;
  }

  async fetchAllTags(brandId: string): Promise<AxiosResponse | undefined> {
    const response = await this.get(TagEndpoint.FETCH_ALL_FOR_BRAND, { brandId });
    return response;
  }
}

export default TagService;
